import $ from "jquery";
import React from "react";
import { MenuItem, SubMenu } from "react-contextmenu";
import { handleUpdateMode } from "../contextLotsDisplays/utils";
export default function Barrier() {
    const BarrierModes = [
        { mode: 0, translationKey: "barrier.modes.Automatic" },
        { mode: 1, translationKey: "barrier.modes.ManualOpen" },
        { mode: 2, translationKey: "barrier.modes.ManualClose" },
        { mode: 3, translationKey: "barrier.modes.Extern" },
    ];
    function updateBarrier(data, document) {
        console.debug('updateBarrier(%o)', data);

        let newHRef = getHrefForBarrierStatus(data.status);
        let svgElement = document.getElementById(data.name);
        console.debug('Barrier? %s => %o', data.name, svgElement);

        $(svgElement).attr("xlink:href", newHRef);
    }
    function getHrefForBarrierStatus(status) {
        switch (status) {
            default:
            case 0:
                return '#barrier_Unknown';
            case 1:
                return '#barrier_Open';
            case 2:
                return '#barrier_Closed';
            case 3:
                return '#barrier_Defect';
        }
    }

    const BarrierContextMenu = (props) => {
        const {
            contextId,
            contextName,
            activeRights,
            showSettings,
            getData,
            t,
        } = props;

        return (
            <div id="contextmenu" className="contextmenu">
                {activeRights.includes("Barrier.SetMode") && (
                    <SubMenu
                        title={
                            <div className="submenu-title">
                                {" "}
                                {t("allgemein.modus")}{" "}
                                <i className="fas fa-chevron-right submenu-icon"></i>{" "}
                            </div>
                        }
                        className="submenu"
                    >
                        {BarrierModes.map(({ mode, translationKey }) => (
                            <React.Fragment key={mode}>
                                <MenuItem
                                    onClick={() =>
                                        handleUpdateMode({
                                            contextId,
                                            contextName,
                                            mode,
                                            type: "Barrier",
                                        })
                                    }
                                >
                                    {t(translationKey)}
                                </MenuItem>
                                <MenuItem divider />
                            </React.Fragment>
                        ))}
                    </SubMenu>
                )}
                {activeRights.some((item) => item.includes("Barrier.")) && (
                    <>
                        <MenuItem divider />

                        <MenuItem
                            onClick={() =>
                                showSettings({
                                    Data: [getData(contextId)],
                                    Type: "Barrier",
                                })
                            }
                            className="activeitem"
                        >
                            {t("allgemein.einstellungen")}
                        </MenuItem>
                    </>
                )}
                <MenuItem divider />

                <MenuItem disabled>{contextName}</MenuItem>

                {activeRights.includes("Debug.ShowIds") && (
                    <>
                        <MenuItem divider />
                        <MenuItem disabled>ID: {contextId}</MenuItem>
                    </>
                )}
            </div>
        );
    };

    return {
        updateBarrier, BarrierModes, BarrierContextMenu
    };
}